import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Vant from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'
import './tailwind.css'
import './styles.css'
import './assets-mobile/styles/global.css'

const legacyHash = window.location.hash
if (legacyHash.startsWith('#/register') || legacyHash.startsWith('#/download')) {
  const legacyPath = legacyHash.slice(1)
  window.history.replaceState(null, '', legacyPath)
}

createApp(App).use(createPinia()).use(router).use(Vant).mount('#app')
